import { News, Html5Video, Text } from '@intigral/shared';
import { isValidUrl } from '@intigral/utils';
import { __ } from '../../translations';
import h from '../../helpers/common';
import f from '../../helpers/formatter';
import { MIXPANEL_EVENTS } from '@intigral/constant/common';
import { useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MixpanelContext } from '../../contexts/MixpanelContext';
import url from '../../helpers/url';

type MarketingLandingPropsType = {
    carousel: {
        mixpanelKey?: string;
        data?: {
            carouselContent?: {
                dateTime?: string;
                enableLinkedContent?: string;
                linkedContent?: {
                    guid?: string;
                    type?: string;
                };
                media?: {
                    key?: string;
                    url?: string;
                    urlAr?: string;
                    contentType?: string;
                }[];
            };
        };
        linkedContent?: {
            guid: string;
            type: string;
        };
        title_resource_key?: string;
        sub_heading_resource_key?: string;
        description_resource_key?: string;
        pagination: boolean;
        id: string;
    };
    screenId?: string | null;
    carouselIndex?: number;
};
export default function MarketingLanding({ carousel, screenId = null, carouselIndex }: MarketingLandingPropsType) {
    const { track } = useContext(MixpanelContext);
    const appConfig = h.getAppConfig();
    const carouselContent = carousel?.data?.carouselContent;
    const lang = h.getLang();
    const mediaObject = carouselContent?.media?.find((item) => {
        return item?.key === 'tv';
    });
    const PrimaryVideoObject = carouselContent?.media?.find((item) => {
        return item?.key === 'primary-video';
    });

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (screenId && carousel?.mixpanelKey && carouselIndex === 0) {
            track(MIXPANEL_EVENTS.SCREEN_VIEWED, {
                'Screen Type': screenId,
                'Component Name': !__(`${carousel?.mixpanelKey}`).includes(carousel?.mixpanelKey)
                    ? __(`${carousel?.mixpanelKey}`)
                    : carousel?.mixpanelKey,
                'Initiated From': searchParams.get('ref') ? url.decodeValue(searchParams.get('ref')) : 'Direct',
            });
        }
    }, []);

    const getVideoUrl = () => {
        if (PrimaryVideoObject && PrimaryVideoObject.contentType?.includes('video')) {
            return getLocalizedUrl(PrimaryVideoObject);
        }
        return '';
    };
    const getLocalizedUrl = (mediaObject) => {
        return ((lang === '' || lang === 'ar') && mediaObject?.urlAr) || mediaObject?.url;
    };

    const getMediaComponent = () => {
        const videoUrl = getVideoUrl();
        const linkedGuid = carouselContent?.linkedContent?.guid ?? '';
        const canOpenExternal =
            !videoUrl && carouselContent?.enableLinkedContent === 'enable' && isValidUrl(__(linkedGuid));

        return (
            ((mediaObject || PrimaryVideoObject) && (
                <Html5Video
                    poster={mediaObject?.contentType?.includes('image') ? getLocalizedUrl(mediaObject) : ''}
                    video={videoUrl}
                    onClick={canOpenExternal ? () => window.open(__(linkedGuid), '_blank') : undefined}
                    style={canOpenExternal ? { cursor: 'pointer' } : undefined}
                />
            )) || <></>
        );
    };

    const getPageTitle = () => {
        if (appConfig?.mlp?.length) {
            const seletedItem = appConfig.mlp.find((item) => {
                return item.id === screenId;
            });
            if (seletedItem?.titleResourceKey) {
                return __(`${seletedItem?.titleResourceKey}`);
            }
        }
        return '';
    };

    return (
        <div className="container" id={`${carousel?.id}${carouselIndex}`}>
            {carouselIndex === 0 && (
                <>
                    <Text as="h2" variant="h2" margin="2x">
                        {getPageTitle()}
                    </Text>
                    {getMediaComponent()}
                </>
            )}
            <News
                title={carousel?.title_resource_key ? __(`${carousel.title_resource_key}`) : ''}
                subtitle={carousel?.sub_heading_resource_key ? __(`${carousel.sub_heading_resource_key}`) : ''}
                description={carousel?.description_resource_key ? __(`${carousel.description_resource_key}`) : ''}
                date={carouselContent?.dateTime ? f.toLocaleDateAndMonthName(carouselContent.dateTime) : ''}
                isLoading={carousel ? false : true}
                border={carouselIndex === 0 ? true : false}
            />
            {carouselIndex !== 0 && getMediaComponent()}
        </div>
    );
}
